export function generateShortId() {
  const chars =
    "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  const randomPart = [...Array(10)]
    .map(() => chars[Math.floor(Math.random() * chars.length)])
    .join("");
  const timePart = Date.now().toString(36);
  return `${randomPart}${timePart}`;
}

export function capitalize(text) {
  if (typeof text !== 'string' || !text.trim()) return '';
  return text.trim().charAt(0).toUpperCase() + text.trim().slice(1);
}
